import * as ajax from '../../../actions/ajax';
import store from '../../../reducers/storeRegistration';
import loginActions from '../../../actions/loginActionCreators';

/**
 * Converts a DataURI to Buffer for file upload
 */
const dataURItoBlob = dataURI => {
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const buffer = Buffer.from(dataURI.split(',')[1], 'base64');
  return new global.Blob([buffer], {
    type: mimeString
  });
};
const uploadSignature = async (signatureHash, signatureData) => {
  // Convert Data URL to blob data for uploading
  const getUploadURL = '/files/uploadUrl';
  const getUploadData = {
    fileName: "".concat(signatureHash, ".png"),
    contentType: 'image/png'
  };
  const fileToUpload = dataURItoBlob(signatureData);
  const responseType = 'text';
  const getDownloadURL = '/files/downloadUrl';
  const getDownloadData = {
    fileName: getUploadData.fileName
  };
  let getRes = null;
  try {
    getRes = await ajax.get(getUploadURL, getUploadData, responseType);
  } catch (e) {
    var _e$response;
    if (((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401) {
      // Token expired - refresh and retry
      await store.dispatch(loginActions.serverToken());
      try {
        getRes = await ajax.get(getUploadURL, getUploadData, responseType);
      } catch (retryError) {
        return 'There was a problem contacting the server to upload the signature.';
      }
    } else {
      return 'There was a problem contacting the server to upload the signature.';
    }
  }
  try {
    const putUrl = getRes.data;
    // don't need to add token retry logic here, the putUrl amazon's not ours
    await ajax.put(putUrl, fileToUpload, getUploadData.contentType, responseType, false, false, false);
  } catch (e) {
    return 'There was a problem uploading the signature.';
  }
  try {
    const res = await ajax.get(getDownloadURL, getDownloadData, 'text');
    return {
      fileName: getUploadData.fileName,
      cachedUrl: res.data
    };
  } catch (e) {
    var _e$response2;
    if (((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 401) {
      // Token expired - refresh and retry
      await store.dispatch(loginActions.serverToken());
      try {
        const res = await ajax.get(getDownloadURL, getDownloadData, 'text');
        return {
          fileName: getUploadData.fileName,
          cachedUrl: res.data
        };
      } catch (retryError) {
        return 'There was a problem downloading the uploaded signature.';
      }
    } else {
      return 'There was a problem downloading the uploaded signature.';
    }
  }
};
export default {
  uploadSignature
};